/**
 * French localization strings for the player.
 */
export const fr = {
  errors: {
    networkError: 'Erreur réseau. Vérifiez votre connexion internet.',
    mediaError: 'Erreur de lecture. Le flux vidéo est indisponible.',
    manifestLoadError: 'Impossible de charger le flux vidéo.',
    bufferStalledError: 'La lecture est interrompue. Reconnexion en cours…',
    fatalError: 'Une erreur est survenue. Veuillez réessayer.',
    timeout: 'Délai de connexion dépassé. Veuillez réessayer.',
    unsupported: 'Votre navigateur ne supporte pas la lecture HLS.',
  },
  controls: {
    play: 'Lecture',
    pause: 'Pause',
    mute: 'Couper le son',
    unmute: 'Activer le son',
    fullscreen: 'Plein écran',
    exitFullscreen: 'Quitter le plein écran',
    retry: 'Réessayer',
  },
  quality: {
    label: 'Qualité vidéo',
    auto: 'Auto',
    audioOnly: 'Audio uniquement',
  },
  status: {
    live: 'EN DIRECT',
    vod: 'VOD',
    ad: 'PUBLICITÉ',
    radio: 'RADIO',
    buffering: 'Chargement…',
    reconnecting: 'Reconnexion…',
    viewers: 'spectateurs',
    viewer: 'spectateur',
  },
} as const;

export type Translations = typeof fr;
